// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3FLzz","title":"Images45_title__2yVAT","images":"Images45_images__1cSQY"};